import { initialState } from './initialState';
import { createReducer, dataAs, requestCases } from './requestState';

export default createReducer(initialState, {
  // `conatct_data` (sic) is the key the Help screen reads.
  ...requestCases('CREATE_CONTACT', { success: dataAs('conatct_data') }),
});
